import { render, staticRenderFns } from "./OrderIndex.vue?vue&type=template&id=0b7651ac"
import script from "./OrderIndex.vue?vue&type=script&lang=js"
export * from "./OrderIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports